import React from 'react';
import {Container} from '@material-ui/core';
import {FirebaseContext} from '../../Firebase';
import {Button, TextField} from '@material-ui/core';
import ReactGoogleSlides from 'react-google-slides';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

const Session4 = () => {
  const firebase = React.useContext(FirebaseContext);
  const group = firebase.userData.group;
  const [scr, setScr] = React.useState(0);
  const [CR, setCR] = React.useState(false);
  const [response, setResponse] = React.useState('');
  const [respQuestions, setRespQuestions] = React.useState('');
  return (
    <div>
      <Container
        style={{
          backgroundColor: 'lightblue',
          padding: '10px',
          minHeight: '270px',
        }}
      >
        {/* SCREENS INTRO ALL GROUP*/}
        {scr === 0 && (
          <div>
            <h3>Bonjour ! Prêt pour un nouvel épisode ensemble ?</h3>
            <p>
              La dernière fois, nous avons parlé des bébés et de leur
              développement. Maintenant, place aux enfants ! Comment se
              développent l’entraide et l’altruisme chez les enfants ?
            </p>
            <p>Suis-nous pour en savoir plus !</p>
            <p>
              Clique sur le bouton continuer une fois que tu as bien compris
              pour continuer.
            </p>
          </div>
        )}
        {scr === 1 && (
          <div style={{textAlign: 'center', width: '100%'}}>
            <ReactGoogleSlides
              width={'100%'}
              height={480}
              slidesLink="https://docs.google.com/presentation/d/1YhzbZsgxpTEcbpkzXtndjL6nB0O4rx7wohoN0aXvozo"
              position={0}
              showControls
            />
            <br />
            <FormControl component="fieldset">
              <FormLabel component="legend">
                Dans l’étude présentée, les bébés choisissent quel type d’objet
                ?
              </FormLabel>
              <RadioGroup
                aria-label="team"
                defaultValue=""
                name="radio-buttons-group-team"
                onChange={(e) => {
                  setCR(true);
                  setResponse(e.target.value);
                }}
              >
                <FormControlLabel
                  value="marionnette"
                  control={<Radio />}
                  label="Une marionnette"
                />
                <FormControlLabel
                  value="hochet"
                  control={<Radio />}
                  label="Un hochet"
                />
                <FormControlLabel
                  value="ballon"
                  control={<Radio />}
                  label="Un ballon"
                />
              </RadioGroup>
            </FormControl>
          </div>
        )}
        {/* SCREENS CONTROL*/}
        {group.toString() === 'control' && scr === 2 && (
          <div>
            <p>
              Te souviens-tu de la rencontre avec Niall Anderson, chanteur à
              l’opéra ?
            </p>
            <p>
              Il nous a présenté son travail et son inspiration en répondant à
              plusieurs questions. Maintenant, à toi d’être le reporter !
            </p>
            <p>Clique sur le bouton continuer</p>
          </div>
        )}
        {group.toString() === 'control' && scr === 3 && (
          <div>
            <p>
              Imagine que tu as la possibilité de rencontrer Niall Anderson à
              l’opéra. Quelles questions souhaiterais-tu lui poser pour mieux
              comprendre sa vie ?
            </p>
            <p>
              Prends le temps que tu veux pour réfléchir, puis inscris tes
              questions dans l’espace à l’écran.
            </p>
            <TextField
              multiline
              fullWidth
              rows="4"
              id="questionsTI"
              label="Tes questions"
              variant="outlined"
              value={respQuestions}
              onChange={(e) => {
                setRespQuestions(e.target.value);
              }}
            />
            <p>Quand tu as terminé, clique sur le bouton ci-dessous.</p>
          </div>
        )}

        {group.toString() === 'control' && scr === 4 && (
          <div>
            <p>
              Nous avons terminé pour aujourd’hui. N’oublie pas de te
              reconnecter dans quelques jours pour notre prochaine séance.
            </p>
            <p>Merci pour ta participation !</p>
            <p>Clique sur le bouton ci-dessous pour quitter la séance.</p>
          </div>
        )}
        {/* SCREENS TEST*/}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 2 && (
            <div>
              <p>
                Te souviens-tu de ta rencontre avec les personnes dans la vidéo
                de la séance précédente ?
              </p>
              <p>
                Ils nous ont présenté leur quotidien, leur vie, et la manière
                dont celle-ci a été chamboulée.
              </p>
              <p>Maintenant, à toi de préparer des questions à leur poser !</p>
            </div>
          )}
        {group.toString() === 'test_a' && scr === 3 && (
          <div>
            <p>
              Imagine que tu as la possibilité de rencontrer les habitants de
              l’île de Tuvalu en personne. Quelles questions souhaiterais-tu
              leur poser pour mieux comprendre comment l’écologie impacte leur
              vie ? Quelles remarques voudrais-tu leur faire ?
            </p>
            <p>
              Prends le temps que tu veux pour réfléchir, puis inscris tes
              questions dans l’espace à l’écran.
            </p>
            <TextField
              multiline
              fullWidth
              rows="4"
              label="Tes questions"
              variant="outlined"
              value={respQuestions}
              onChange={(e) => {
                setRespQuestions(e.target.value);
              }}
            />
            <p>Quand tu as terminé, clique sur le bouton ci-dessous. </p>
          </div>
        )}
        {group.toString() === 'test_b' && scr === 3 && (
          <div>
            <p>
              Imagine que tu as la possibilité de rencontrer le jeune garçon de
              la vidéo et sa maman. Quelles questions souhaiterais-tu leur poser
              pour mieux comprendre comment l’hospitalisation impacte leur vie ?
              Quelles remarques voudrais-tu leur faire ?
            </p>
            <p>
              Prends le temps que tu veux pour réfléchir, puis inscris tes
              questions dans l’espace à l’écran.
            </p>
            <TextField
              multiline
              fullWidth
              rows="4"
              label="Tes questions"
              variant="outlined"
              value={respQuestions}
              onChange={(e) => {
                setRespQuestions(e.target.value);
              }}
            />
            <p>Quand tu as terminé, clique sur le bouton ci-dessous. </p>
          </div>
        )}
        {group.toString() === 'test_c' && scr === 3 && (
          <div>
            <p>
              Imagine que tu as la possibilité de rencontrer les familles qui
              ont du mal à trouver un logement. Quelles questions
              souhaiterais-tu leur poser pour mieux comprendre comment cela
              impacte leur vie ? Quelles remarques voudrais-tu leur faire ?
            </p>
            <p>
              Prends le temps que tu veux pour réfléchir, puis inscris tes
              questions dans l’espace à l’écran.
            </p>
            <TextField
              multiline
              fullWidth
              rows="4"
              label="Tes questions"
              variant="outlined"
              value={respQuestions}
              onChange={(e) => {
                setRespQuestions(e.target.value);
              }}
            />
            <p>Quand tu as terminé, clique sur le bouton ci-dessous. </p>
          </div>
        )}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 4 && (
            <div>
              <p>
                Nous avons terminé pour aujourd’hui. N’oublie pas de te
                reconnecter dans quelques jours pour notre prochaine séance.
              </p>
              <p>Merci pour ta participation !</p>
              <p>Clique sur le bouton ci-dessous pour quitter la séance.</p>
            </div>
          )}
      </Container>
      {/* BUTTON*/}
      <Button
        style={{display: 'block', margin: 'auto'}}
        disabled={scr === 1 && !CR}
        variant="contained"
        color="primary"
        onClick={() => {
          if (scr === 3) {
            // save TEST DATA
            let now = new Date();
            firebase
              .databehav(firebase.userData.pseudo)
              .collection('session4')
              .add({
                date: now,
                response: response,
                respQuestions: respQuestions,
              })
              .catch((error) => {
                console.log(error);
              });
          }
          if (scr === 4) {
            firebase.signoutUser();
          } else {
            setScr(scr + 1);
          }
        }}
      >
        Continuer
      </Button>
    </div>
  );
};
export default Session4;
